import React, { useContext } from 'react';
import ButtonGreen from './ButtonGreen';
import GradientBorder from '../../ui/GradientBorder';
import greenpillmetamask from '../../assets/greenpill/greenpillmetamask.png';
import greenpillphantom from '../../assets/greenpill/greenpillphantom.png';
import { getMetaMaskProvider } from '../../blockchainInteraction/finaliseGrading';
import { toast } from 'sonner';
import { AuthContext } from '../../contexts/AuthContext';
import { updateWallet } from '../../apis/geenpills/updateWallet';

// const metaConnection = async (linkedWallet) => {
//     const metaMaskProvider = getMetaMaskProvider();
//     if (!metaMaskProvider) {
//         const installUrl = 'https://metamask.io/download.html';
//         toast.info('Opening MetaMask installation page in a new tab...');
//         window.open(installUrl, '_blank'); // Open the URL in a new tab
//         // toast.error('MetaMask is not installed or unavailable');
//         return;
//     }
//     const accounts = await metaMaskProvider.request({
//         method: 'eth_requestAccounts',
//     });
//     console.log(accounts);
//     if (!accounts || accounts.length === 0) {
//         toast.error('Failed to connect wallet');
//         return;
//     }

//     if (accounts[0]?.toLowerCase() === linkedWallet?.toLowerCase()) {
//         toast?.error('This wallet is already connected to your profile.You can mint now');
//         return;
//     }

//     console.log('update the wallet here and then navigate the user back to minting after updating the state');
// };

const metaConnection = async (linkedWallet) => {
    const metaMaskProvider = getMetaMaskProvider();

    if (!metaMaskProvider) {
        const installUrl = 'https://metamask.io/download.html';
        toast.info('Opening MetaMask installation page in a new tab...');
        window.open(installUrl, '_blank');
        return;
    }

    try {
        // Always prompt MetaMask popup
        const accounts = await metaMaskProvider.request({
            method: 'wallet_requestPermissions',
            params: [{ eth_accounts: {} }],
        });

        // Now explicitly request selected accounts again
        const selectedAccounts = await metaMaskProvider.request({
            method: 'eth_requestAccounts',
        });

        if (!selectedAccounts || selectedAccounts.length === 0) {
            toast.error('No wallet selected. Connection cancelled.');
            return;
        }

        const newWallet = selectedAccounts[0]?.toLowerCase();
        const existingWallet = linkedWallet?.toLowerCase();

        if (newWallet === existingWallet) {
            toast.error(
                'This wallet is already connected. To switch wallets, please disconnect from MetaMask first and choose the account to which you want to connect.'
            );
            return;
        }

        return newWallet;
    } catch (error) {
        console.error('MetaMask connection error:', error);
        toast.error('Failed to connect MetaMask wallet.');
    }
};

const ChangeWallet = ({ close, handleChangeWalletAddress, type, linkedWallet, from }) => {
    const { dispatch } = useContext(AuthContext);
    const changeHandler = async () => {
        const newWallet = await metaConnection(linkedWallet);
        if (newWallet && newWallet !== linkedWallet) {
            const response = await updateWallet(newWallet, undefined);
            if (response?.response?.data?.code === 400) {
                toast?.error(response?.response?.data?.message);
            }

            if (response?.evmAddress) {
                toast?.success('Wallet changed successfully');
                dispatch({ type: 'changeWalletEVM', payload: newWallet });
                // or 'phantom' depending on type
            }
        }
        handleChangeWalletAddress('', '');
    };

    return (
        <div>
            <div className="flex items-center justify-between">
                <button
                    className="   rounded-full   "
                    onClick={() => {
                        handleChangeWalletAddress('', '');
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <circle cx="14.5713" cy="15.4287" r="14.5713" fill="#353535" />
                        <path
                            d="M17.6378 10.3794L16.4846 9.29346L9.96875 15.4287L16.4846 21.564L17.6378 20.4781L12.2753 15.4287L17.6378 10.3794Z"
                            fill="#9B9B9B"
                        />
                    </svg>
                </button>
                <h1
                    className="text-2xl font-semibold text-[white]"
                    style={{
                        textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                    }}
                >
                    {from === 'mint' ? 'Not Your Linked Wallet – Switch Anyway?' : 'Change wallet linked to profile'}{' '}
                    {''}
                </h1>
                <button
                    className="   rounded-full  "
                    onClick={() => {
                        close();
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <circle cx="15" cy="15" r="15" fill="#393939" />
                        <path d="M20.5918 10L10.5914 20.0004" stroke="#9B9B9B" strokeWidth="2" strokeLinecap="round" />
                        <path d="M20 20L9.99964 9.99964" stroke="#9B9B9B" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </button>
            </div>
            <p className="text-[#CFCFCF] mt-3 mb-6 text-center ">
                Update your linked wallet below, or go back and reconnect the wallet already linked to use existing
                wallet
            </p>

            <div className="flex items-center justify-center">
                <GradientBorder
                    radiusBorder={'.25rem'}
                    color2={'rgba(80, 108, 102, 0)'}
                    color1={'rgba(105, 159, 132, 1)'}
                    bg="bg-[#1E3D36]"
                    shadow="shadow-button-shadow"
                >
                    <button
                        onClick={changeHandler}
                        type="button"
                        className={` px-4 py-2 flex items-center gap-2   justify-between`}
                    >
                        <img
                            className="w-7 h-7 object-cover rounded-full"
                            src={type === 'metamask' ? greenpillmetamask : greenpillphantom}
                            alt="metamask"
                        />
                        <span>Change Wallet</span>
                    </button>
                </GradientBorder>
            </div>
        </div>
    );
};

export default ChangeWallet;
